import {
  CARDS_REQUEST,
  CARDS_SUCCESS,
  CARDS_ERROR,

  CARDS_ACCS_REQUEST,
  CARDS_ACCS_SUCCESS,
  CARDS_ACCS_ERROR,

  CARDS_BALANCE_REQUEST,
  CARDS_BALANCE_SUCCESS,
  CARDS_BALANCE_ERROR,

  CARDS_CLIENT_BALANCE_REQUEST,
  CARDS_CLIENT_BALANCE_SUCCESS,
  CARDS_CLIENT_BALANCE_ERROR,

  CARDS_TRANSACTIONS_REQUEST,
  CARDS_TRANSACTIONS_SUCCESS,
  CARDS_TRANSACTIONS_ERROR,

  CARDS_UPDATE_REQUEST,
  CARDS_UPDATE_SUCCESS,
  CARDS_UPDATE_ERROR,
  CARDS_UPDATE_RESET,

  CARDS_BLOCK_REQUEST,
  CARDS_BLOCK_SUCCESS,
  CARDS_BLOCK_ERROR,
  CARDS_BLOCK_RESET,

  CARDS_UNBLOCK_REQUEST,
  CARDS_UNBLOCK_SUCCESS,
  CARDS_UNBLOCK_ERROR,
  CARDS_UNBLOCK_RESET,

  CARDS_MONEY_TO_ACC_REQUEST,
  CARDS_MONEY_ACC_TO_ACC_REQUEST,

  CARDS_FUEL_TO_ACC_REQUEST,
  CARDS_FUEL_ACC_TO_ACC_REQUEST,
  
  CARDS_ACCS_CREATE,

  CARDS_GET_REPORT,

  SIMPLE_POST,


  CARDS_CARD_USER_LOGIN_REQUEST,
  CARDS_CARD_USER_LOGIN_SUCCESS,
  CARDS_CARD_USER_LOGIN_ERROR,

  CARDS_NEW_CARD_USER_LOGIN_REQUEST,
  CARDS_NEW_CARD_USER_LOGIN_SUCCESS,
  CARDS_NEW_CARD_USER_LOGIN_ERROR,

  CARDS_CARD_USER_REQUEST,
  CARDS_CARD_USER_SUCCESS,
  CARDS_CARD_USER_ERROR,

} from "../actions/cards";
import { AUTH_LOGOUT } from "../actions/auth";
import Vue from "vue";
import HTTP from "@/utils/http.js";

const state = {
  cards_get_status: "",
  cards_once_loaded: false,
  cards: [],

  cards_accs_get_status: "",
  cards_accs_once_loaded: false,
  cards_accs: [],

  cards_balances_get_status: "",
  cards_balances_once_loaded: false,
  balances: [],

  cards_client_balance_get_status: "",
  cards_client_balance_once_loaded: false,
  cards_client_balance: null,

  cards_transactions_get_status: "",
  cards_transactions_once_loaded: false,
  transactions: [],

  cards_update_status: "",
  cards_block_status: "",

  currency_name: "тенге",

  card_user_login_get_status: "",
  card_user_login: {}, // доступ в личный кабинет

  card_user_get_status: "",
  card_user_once_loaded: false,
  card_user: {} // личный кабинет -> запрос данных карты
};

const getters = {
  //getCurrencyName: state => state.currency_name,

  getCards: state => acc_id => acc_id ? state.cards.filter(c => c.account_id == acc_id) : state.cards,
  getCardsByAccs: state => acc_ids => acc_ids.length > 0 ? state.cards.filter(c => acc_ids.indexOf( c.account_id ) >= 0) : [],
  getCardById: state => id => state.cards.find(c => c.id == id),
  getCardsCount: state => state.cards ? state.cards.length : 0,
  getActiveCardsCount: state => state.cards ? state.cards.filter(c => !c.block).length : 0,
  getBlockedCardsCount: state => state.cards ? state.cards.filter(c => c.block).length : 0,

  isCardsLoading: state => state.cards_get_status === 'loading',
  isCardsFailed: state => state.cards_get_status === 'error',
  cardsOnceLoaded: state => state.cards_once_loaded,

  getCardsAccs: state => state.cards_accs,
  getCardsAccsById: state => id => state.cards_accs.find( acc => acc.id == id),
  getCardsAccsNotRemoved: state => state.cards_accs.filter(ca => !ca.removed),
  isCardsAccsLoading: state => state.cards_accs_get_status === 'loading',
  isCardsAccsFailed: state => state.cards_accs_get_status === 'error',
  cardsAccsOnceLoaded: state => state.cards_accs_once_loaded,

  getCardAccBalances: state => state.balances,
  getCardAccB: state => acc_id => state.balances.find(b => b.account_id == acc_id),
  getCardAccName: (state, getters) => acc_id => getters.getCardAccB(acc_id)?.account_name,
  getCardAccFuelBalance: (state, getters) => acc_id => getters.getCardAccB(acc_id)?.fuels ?? [],
  getCardAccFuelPrices: (state, getters) => (acc_id, product_id) => getters.getCardAccFuelBalance(acc_id)?.find(p => p.id == product_id)?.price ?? [],
  getCardAccFuelQuantityByPrice: (state, getters) => (acc_id, product_id, price) => {
    let b = getters.getCardAccFuelBalance(acc_id)?.find(p => p.id == product_id);
    return b?.quantity[b.price.findIndex(p => p == price)] ?? 0;
  },
  getCardAccMoneyBalance: (state, getters) => acc_id => getters.getCardAccB(acc_id)?.money ?? 0,
  isCardAccFuelEmpty: (state, getters) => acc_id => !(getters.getCardAccB(acc_id)?.fuels?.find(f=>f.quantity?.length)),

  getMoneyBalance: (state, getters) => {
    let moneyBalance = 0;
    for (let i = 0; i < state.balances.length; i++) {
      const b = state.balances[i];
      if (b.money > 0) moneyBalance += b.money;
    }
    return moneyBalance + getters.getClientMoneyBalance;
  },
  getFuelBalances: (state, getters) => {
    let fuelBalances = [];
    let reducer = (accumulator, currentValue) => accumulator + currentValue;
    for (let i = 0; i < state.balances.length; i++) {
      let b = state.balances[i];
      b?.fuels?.map(value => {
        let found = fuelBalances.find(i => i.id === value.id);
        if (found) found.quantity += value.quantity.reduce(reducer, 0);
        else fuelBalances.push({ id: value.id, name: value.name, quantity: value.quantity.reduce(reducer, 0) });
      });
    }
    reducer = (accumulator, currentValue) => accumulator + currentValue.quantity;
    getters.getClientFuelBalance.forEach(b => {
      let found = fuelBalances.find(i => i.id === b.product_id);
      if (found) found.quantity += b.values.reduce(reducer, 0);
      else fuelBalances.push({ id: b.product_id, name: b.product_name, quantity: b.values.reduce(reducer, 0) });
    });
    return fuelBalances;
  },

  cardsBalancesOnceLoaded: state => state.cards_balances_once_loaded,
  isCardsBalanceLoading: state => state.cards_balances_get_status === 'loading',
  isCardsBalanceSucceeded: state => state.cards_balances_get_status === 'success',
  isCardsBalanceFailed: state => state.cards_balances_get_status === 'error',

  getTransactions: state => state.transactions,
  cardsTransactionsOnceLoaded: state => state.cards_transactions_once_loaded,
  isCardsTransactionsLoading: state => state.cards_transactions_get_status === 'loading',
  isCardsTransactionsFailed: state => state.cards_transactions_get_status === 'error',

  isCardsUpdateLoading: state => state.cards_update_status === 'loading',
  hasCardsUpdateFailed: state => state.cards_update_status === 'error',
  hasCardsUpdateSucceeded: state => state.cards_update_status === 'success',

  isCardsBlockLoading: state => state.cards_block_status === 'loading',
  hasCardsBlockFailed: state => state.cards_block_status === 'error',
  hasCardsBlockSucceeded: state => state.cards_block_status === 'success',

  getClientMoneyBalance: state => state.cards_client_balance?.money ?? 0,
  getClientFuelBalance: state => state.cards_client_balance?.fuel ?? [],
  getClientFuelPrices: (state, getters) => product_id => [...getters.getClientFuelBalance?.find(b => b.product_id == product_id)?.values ?? []].sort((a, b) => a.price - b.price),
  getClientFuelQuantityByPrice: (state, getters) => (product_id, price) => getters.getClientFuelPrices(product_id).find(p => p.price == price)?.quantity ?? 0,

  isCardsClientBalanceLoading: state => state.cards_client_balance_get_status === 'loading',
  isCardsClientBalanceFailed: state => state.cards_client_balance_get_status === 'error',
  cardsClientBalanceOnceLoaded: state => state.cards_client_balance_once_loaded,

  getCardUserLoginLoading: state => state.card_user_login_get_status == 'loading',
  getCardUserLoginFailed: state => state.card_user_login_get_status == 'error',
  getCardUserLoginSucceeded: state => state.card_user_login_get_status == 'success',

  getCardUserLogin: state => state.card_user_login,

  getCardUserLoading: state => state.card_user_get_status == 'loading',
  getCardUserFailed: state => state.card_user_get_status == 'error',
  getCardUserSucceeded: state => state.card_user_get_status == 'success',
  cardsUserOnceLoaded: state => state.card_user_once_loaded,

  getCardUser: state => state.card_user,

};

const actions = {
  [CARDS_REQUEST]: ({ commit, dispatch }) => {    
    commit(CARDS_REQUEST);
    return new Promise((resolve, reject) => {    
      HTTP({ url: "cards" })
        .then(resp => {
          commit(CARDS_SUCCESS, resp.data);
          console.log( resp.data );
          resolve(resp);
        })
        .catch((err) => {
          commit(CARDS_ERROR);
          if (err.status === 401) {
            dispatch(AUTH_LOGOUT);
          }
          reject(err);
        });
    });
  },
  [CARDS_ACCS_REQUEST]: ({ commit, dispatch }) => {
    commit(CARDS_ACCS_REQUEST);
    HTTP({ url: "cards/accs" })
      .then(resp => {
        commit(CARDS_ACCS_SUCCESS, resp.data);
      })
      .catch((err) => {
        commit(CARDS_ACCS_ERROR);
        if (err.status === 401) {
          dispatch(AUTH_LOGOUT);            
        }
      });
  },
  [CARDS_BALANCE_REQUEST]: ({ commit, dispatch }) => {
    commit(CARDS_BALANCE_REQUEST);
    HTTP({ url: "cards/balance" })
      .then(resp => {
        commit(CARDS_BALANCE_SUCCESS, resp.data);
      })
      .catch((err) => {
        commit(CARDS_BALANCE_ERROR);
        if (err.status === 401) {
          dispatch(AUTH_LOGOUT);
        }
      });
  },
  [CARDS_CLIENT_BALANCE_REQUEST]: ({ commit, dispatch }) => {
    commit(CARDS_CLIENT_BALANCE_REQUEST);
    HTTP({ url: "cards/client_balance" })
      .then(resp => {
        commit(CARDS_CLIENT_BALANCE_SUCCESS, resp.data);
      })
      .catch((err) => {
        commit(CARDS_CLIENT_BALANCE_ERROR);
        if (err.status === 401) {
          dispatch(AUTH_LOGOUT);
        }
      });
  },
  [CARDS_TRANSACTIONS_REQUEST]: ({ commit, dispatch }) => {
    commit(CARDS_TRANSACTIONS_REQUEST);
    HTTP({ url: "cards/transactions" })
      .then(resp => {
        commit(CARDS_TRANSACTIONS_SUCCESS, resp.data);
      })
      .catch((err) => {
        commit(CARDS_TRANSACTIONS_ERROR);
        if (err.status === 401) {
          dispatch(AUTH_LOGOUT);
        }
      });
  },
  [CARDS_UPDATE_REQUEST]: ({ commit, dispatch }, req) => {
    return new Promise((resolve, reject) => {
      commit(CARDS_UPDATE_REQUEST);
      HTTP({ url: "cards", data: req, method: "POST" })
        .then(resp => {
          commit(CARDS_UPDATE_SUCCESS, req);
          resolve(resp);
        })
        .catch(err => {
          commit(CARDS_UPDATE_ERROR, err);
          if (err.status === 401) {
            dispatch(AUTH_LOGOUT);
          }
          reject(err);
        });
    });
  },
  [CARDS_BLOCK_REQUEST]: ({ commit, dispatch }, req) => {
    return new Promise((resolve, reject) => {
      commit(CARDS_BLOCK_REQUEST);
      HTTP({ url: "cards/block", data: req, method: "POST" })
        .then(resp => {
          commit(CARDS_BLOCK_SUCCESS, req.card_id);
          resolve(resp);
        })
        .catch(err => {
          commit(CARDS_BLOCK_ERROR, err);
          if (err.status === 401) {
            dispatch(AUTH_LOGOUT);
          }
          reject(err);
        });
    });
  },
  [CARDS_UNBLOCK_REQUEST]: ({ commit, dispatch }, req) => {
    return new Promise((resolve, reject) => {
      commit(CARDS_UNBLOCK_REQUEST);
      HTTP({ url: "cards/unblock", data: req, method: "POST" })
        .then(resp => {
          commit(CARDS_UNBLOCK_SUCCESS, req.card_id);
          resolve(resp);
        })
        .catch(err => {
          commit(CARDS_UNBLOCK_ERROR, err);
          if (err.status === 401) {
            dispatch(AUTH_LOGOUT);
          }
          reject(err);
        });
    });
  },

  [CARDS_MONEY_TO_ACC_REQUEST]: ({ dispatch }, data) => {
    return dispatch(SIMPLE_POST, { url: "cards/money_to_acc", data });
  },
  [CARDS_MONEY_ACC_TO_ACC_REQUEST]: ({ dispatch }, data) => {
    return dispatch(SIMPLE_POST, { url: "cards/money_acc_to_acc", data });
  },

  [CARDS_FUEL_TO_ACC_REQUEST]: ({ dispatch }, data) => {
    return dispatch(SIMPLE_POST, { url: "cards/fuel_to_acc", data });
  },
  [CARDS_FUEL_ACC_TO_ACC_REQUEST]: ({ dispatch }, data) => {
    return dispatch(SIMPLE_POST, { url: "cards/fuel_acc_to_acc", data });
  },

  [CARDS_ACCS_CREATE]:({ dispatch }, req)=>{
    return new Promise((resolve, reject) => {
      HTTP({ url: "cards/accs", data: req, method: "POST" })
      .then(resp => {
        resolve(resp);
      })
      .catch(err => {
        if (err.status === 401) {
          dispatch(AUTH_LOGOUT);
        }
        reject(err);
      });
    });
  },

  [CARDS_GET_REPORT]: ({ dispatch }, data) => {
    return dispatch(SIMPLE_POST, { url: "cards/get_report", data });
  },
  [CARDS_CARD_USER_LOGIN_REQUEST]: ({ commit, dispatch }, req) => {
    return new Promise((resolve, reject) => {
      commit(CARDS_CARD_USER_LOGIN_REQUEST);
      HTTP({ url: "cards/user_auth_data", data: req, method: "POST" })
        .then(resp => {
          commit(CARDS_CARD_USER_LOGIN_SUCCESS, resp.data);
          resolve(resp);
        })
        .catch(err => {
          commit(CARDS_CARD_USER_LOGIN_ERROR, err);
          if (err.status === 401) {
            dispatch(AUTH_LOGOUT);
          }
          reject(err);
        });
    });
  },
  [CARDS_NEW_CARD_USER_LOGIN_REQUEST]: ({ commit, dispatch }, req) => {
    return new Promise((resolve, reject) => {
      commit(CARDS_NEW_CARD_USER_LOGIN_REQUEST);
      HTTP({ url: "cards/user_create", data: req, method: "POST" })
        .then(resp => {
          commit(CARDS_NEW_CARD_USER_LOGIN_SUCCESS, req.data);
          resolve(resp);
        })
        .catch(err => {
          console.log(err);
          commit(CARDS_NEW_CARD_USER_LOGIN_ERROR, err);
          if (err.status === 401) {
            dispatch(AUTH_LOGOUT);
          }
          reject(err);
        });
    });
  },  

  [CARDS_CARD_USER_REQUEST]: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      commit(CARDS_CARD_USER_REQUEST);
      return HTTP({ url: "cards/user_card", method: "GET" })
        .then(resp => {
          commit(CARDS_CARD_USER_SUCCESS, resp.data);
          //console.log(resp.data);
          resolve(resp);
        })
        .catch(err => {
          console.log(err);
          commit(CARDS_CARD_USER_ERROR, err);
          if (err.status === 401) {
            dispatch(AUTH_LOGOUT);
          }
          reject(err);
        });
    });
  },


  //HELPER
  [SIMPLE_POST]:({ dispatch }, { url, data })=>{
    return new Promise((resolve, reject) => {
      HTTP({ url, data, method: "POST" })
      .then(resp => {
        resolve(resp);
      })
      .catch(err => {
        if (err.status === 401) {
          dispatch(AUTH_LOGOUT);
        }
        reject(err);
      });
    });
  }
};

const mutations = {
  [CARDS_REQUEST]: state => {
    state.cards_get_status = "loading";
  },
  [CARDS_SUCCESS]: (state, data) => {
    state.cards_get_status = "success";
    Vue.set(state, "cards", data);
    state.cards_once_loaded = true;
  },
  [CARDS_ERROR]: state => {
    state.cards_get_status = "error";
    state.cards_once_loaded = true;
  },

  [CARDS_ACCS_REQUEST]: state => {
    state.cards_accs_get_status = "loading";
  },
  [CARDS_ACCS_SUCCESS]: (state, data) => {
    state.cards_accs_get_status = "success";
    Vue.set(state, "cards_accs", data);
    state.cards_accs_once_loaded = true;
  },
  [CARDS_ACCS_ERROR]: state => {
    state.cards_accs_get_status = "error";
    state.cards_accs_once_loaded = true;
  },

  [CARDS_BALANCE_REQUEST]: state => {
    state.cards_balances_get_status = "loading";
  },
  [CARDS_BALANCE_SUCCESS]: (state, data) => {
    state.cards_balances_get_status = "success";
    Vue.set(state, "balances", data);
    state.cards_balances_once_loaded = true;
  },
  [CARDS_BALANCE_ERROR]: state => {
    state.cards_balances_get_status = "error";
    state.cards_balances_once_loaded = true;
  },

  [CARDS_CLIENT_BALANCE_REQUEST]: state => {
    state.cards_client_balance_get_status = "loading";
  },
  [CARDS_CLIENT_BALANCE_SUCCESS]: (state, data) => {
    state.cards_client_balance_get_status = "success";
    Vue.set(state, "cards_client_balance", data);
    state.cards_client_balance_once_loaded = true;
  },
  [CARDS_CLIENT_BALANCE_ERROR]: state => {
    state.cards_client_balance_get_status = "error";
    state.cards_client_balance_once_loaded = true;
  },

  [CARDS_TRANSACTIONS_REQUEST]: state => {
    state.cards_transactions_get_status = "loading";
  },
  [CARDS_TRANSACTIONS_SUCCESS]: (state, data) => {
    state.cards_transactions_get_status = "success";
    Vue.set(state, "transactions", data);
    state.cards_transactions_once_loaded = true;
  },
  [CARDS_TRANSACTIONS_ERROR]: state => {
    state.cards_transactions_get_status = "error";
    state.cards_transactions_once_loaded = true;
  },

  [CARDS_UPDATE_REQUEST]: state => {
    state.cards_get_status = "loading";
  },
  [CARDS_UPDATE_SUCCESS]: (state, data) => {
    state.cards_get_status = "success";
    let body = JSON.parse(data.body);
    console.log(body);
    for (let i = 0; i < state.cards.length; i++) {
      const n = state.cards[i];
      if (n.id === data.card_id) {
        console.log('updated card ' + data.card_id);
        let new_card = Object.assign({}, n);
        new_card.holder_name = body.holder_name;
        new_card.pin = body.pin;
        new_card.volume_limit.target_values = body.volume_limit.target_values;
        new_card.money_limit.target_values = body.money_limit.target_values;

        state.cards.splice(i, 1, new_card)
      }
    }
  },
  [CARDS_UPDATE_ERROR]: state => {
    state.cards_get_status = "error";
  },
  [CARDS_UPDATE_RESET]: state => {
    state.cards_get_status = "";
  },

  [CARDS_BLOCK_REQUEST]: state => {
    state.cards_block_status = "loading";
  },
  [CARDS_BLOCK_SUCCESS]: (state, card_id) => {
    state.cards_block_status = "success";
    for (let i = 0; i < state.cards.length; i++) {
      const n = state.cards[i];
      if (n.id === card_id) {
        console.log('blocked card ' + card_id);
        let new_card = Object.assign({}, n);
        new_card.block = true;
        state.cards.splice(i, 1, new_card)
      }
    }
  },
  [CARDS_BLOCK_ERROR]: state => {
    state.cards_block_status = "error";
  },
  [CARDS_BLOCK_RESET]: state => {
    state.cards_block_status = "";
  },

  [CARDS_UNBLOCK_REQUEST]: state => {
    state.cards_block_status = "loading";
  },
  [CARDS_UNBLOCK_SUCCESS]: (state, card_id) => {
    state.cards_block_status = "success";
    for (let i = 0; i < state.cards.length; i++) {
      const n = state.cards[i];
      if (n.id === card_id) {
        let new_card = Object.assign({}, n);
        new_card.block = false;
        state.cards.splice(i, 1, new_card)
      }
    }
  },
  [CARDS_UNBLOCK_ERROR]: state => {
    state.cards_block_status = "error";
  },
  [CARDS_UNBLOCK_RESET]: state => {
    state.cards_block_status = "";
  },

  [CARDS_CARD_USER_LOGIN_SUCCESS]: (state, user) => {
    state.card_user_login_get_status = "success";
    state.card_user_login = user;
  },

  [CARDS_CARD_USER_LOGIN_REQUEST]: state => {
    state.card_user_login_get_status = "loading";
  },

  [CARDS_CARD_USER_LOGIN_ERROR]: state => {
    state.card_user_login_get_status = "error";
  },

  [CARDS_NEW_CARD_USER_LOGIN_SUCCESS]: (state, user) => {
    state.card_user_login_get_status = "success";
    state.card_user_login = user;
  },

  [CARDS_NEW_CARD_USER_LOGIN_REQUEST]: state => {
    state.card_user_login_get_status = "loading";
  },

  [CARDS_NEW_CARD_USER_LOGIN_ERROR]: state => {
    state.card_user_login_get_status = "error";
  },

  [CARDS_CARD_USER_SUCCESS]: (state, card) => {
    state.card_user_get_status = "success";
    state.card_user = card;
    state.card_user_once_loaded = true;
    Vue.set(state, "card_user", card);
  },

  [CARDS_CARD_USER_REQUEST]: state => {
    state.card_user_get_status = "loading";
  },

  [CARDS_CARD_USER_ERROR]: state => {
    state.card_user_get_status = "error";
    state.card_user_once_loaded = true;
  },


  [AUTH_LOGOUT]: state => {
    state.cards_get_status = "";
    state.cards_once_loaded = false;
    state.cards = [];

    state.cards_accs_get_status = "";
    state.cards_accs_once_loaded = false;
    state.cards_accs = [];

    state.cards_balances_get_status = "";
    state.cards_balances_once_loaded = false;
    state.balances = [];

    state.cards_client_balance_get_status = "";
    state.cards_client_balance_once_loaded = false;
    state.cards_client_balance = null;

    state.cards_transactions_get_status = "";
    state.cards_transactions_once_loaded = false;
    state.transactions = [];

    state.cards_update_status = "";
    state.cards_block_status = "";
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};